const routes = [
    {
        name: 'index',
        path: '/',
        component: () => import('@/view/appIndex'),
        meta: {
            title: ' '
        }
    },
    {
        name: 'serviceList',
        path: '/service/list',
        component: () => import('@/view/service/list'),
        meta: {
            title: '视频号服务',
            keepAlive: true
        }
    },
    {
        name: 'serviceDetail',
        path: '/service/detail',
        component: () => import('@/view/service/detail'),
        meta: {
            title: '服务详情'
        }
    },
    {
        name: 'developDetail',
        path: '/develop/detail',
        component: () => import('@/view/develop/detail'),
        meta: {
            title: '开发详情'
        }
    },
    {
        name: 'serviceForm',
        path: '/service/form',
        component: () => import('@/view/service/form'),
        meta: {
            title: '表单提交'
        }
    },
    {
        name: 'goodsDetail',
        path: '/goods/detail',
        component: () => import('@/view/goods/detail'),
        meta: {
            title: '商品详情'
        }
    },
    {
        name: 'login',
        path: '/login/login',
        component: () => import('@/view/login/login'),
        meta: {
            title: '登录'
        }
    },
    {
        name: 'register',
        path: '/login/register',
        component: () => import('@/view/login/register'),
        meta: {
            title: '注册'
        }
    },
    {
        name: 'forget',
        path: '/login/forget',
        component: () => import('@/view/login/forget'),
        meta: {
            title: '忘记密码'
        }
    },
    {
        name: 'guide',
        path: '/guide/guide',
        component: () => import('@/view/guide/guide'),
        meta: {
            title: ''
        }
    },
    {
        name: 'download',
        path: '/guide/download',
        component: () => import('@/view/guide/download'),
        meta: {
            title: '视频号下载'
        }
    },
    {
        name: 'short',
        path: '/guide/short',
        component: () => import('@/view/guide/short'),
        meta: {
            title: '短剧CPS'
        }
    },
    {
        name: 'search',
        path: '/search/search',
        component: () => import('@/view/search/search'),
        meta: {
            title: '搜索',
            keepAlive: true
        }
    },
    {
        name: 'my',
        path: '/my/my',
        component: () => import('@/view/my/my'),
        meta: {
            title: '个人中心'
        }
    },
    {
        name: 'notice',
        path: '/notice/notice',
        component: () => import('@/view/notice/notice'),
        meta: {
            title: '平台公告'
        }
    },
    {
        name: 'noticeDetail',
        path: '/notice/noticeDetail',
        component: () => import('@/view/notice/noticeDetail'),
        meta: {
            title: '公告详情'
        }
    },
    {
        name: 'expert',
        path: '/expert/expert',
        component: () => import('@/view/expert/expert'),
        meta: {
            title: '找达人'
        }
    },
    {
        name: 'short',
        path: '/short/short',
        component: () => import('@/view/short/short'),
        meta: {
            title: '短剧'
        }
    },
    {
        name: 'union',
        path: '/union/union',
        component: () => import('@/view/union/union'),
        meta: {
            title: '全域赚钱联盟'
        }
    }
];

export default routes
